import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {CommonsModule} from "../../commons/angular/commons.module";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {
  PricePlanBundleStateViewComponent
} from "./components/price-plan-bundle-state-view/price-plan-bundle-state-view.component";
import {
  PricePlansBundleHierarchyComponent
} from "./components/price-plans-bundle-hierarchy/price-plans-bundle-hierarchy.component";
import {PricePlanTreeNodeComponent} from "./components/price-plan-tree-node/price-plan-tree-node.component";
import {NgxEchartsModule} from "ngx-echarts";
import {PricePlanDetailsViewComponent} from "./components/price-plan-details-view/price-plan-details-view.component";
import {AccountsModule} from "../../account/angular/accounts.module";


@NgModule({
  declarations: [
    PricePlanBundleStateViewComponent,
    PricePlansBundleHierarchyComponent,
    PricePlanTreeNodeComponent,
    PricePlanDetailsViewComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    NgxEchartsModule.forChild(),
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    AccountsModule
  ],
  exports: [],
  providers: []
})

export class PricePlanModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapPricePlanModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(PricePlanModule);
};

export const downgradedPricePlanModule = downgradeModule(bootstrapPricePlanModule);
